import { Model } from 'dva'
import { Action } from './types'
import { OrganisationsService } from '../../Service'
import { IsObject } from '../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const Actions: Model = {
  namespace: 'actions',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = false, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        const actions = yield select((state: any) => state.actions.list)
        const org = yield select((state: any) => state.flowLayout.flow.organisation)
        const flow = yield select((state: any) => state.flowLayout.flow)
        const flowConfigVersion = yield select((state: any) => state.flowLayout.version?.version)
        if (!(actions.length > 0 && useCache)) {
          const flowActions = yield call(
            OrganisationsService.organisationsFlowsVersionsActionsList,
            {
              organisationUuid: org?.uuid,
              flowUuid: flow?.uuid,
              flowConfigVersion,
              organisation: [org?.id],
            }
          )
          console.info('flowActions: ', flowActions)
          yield put({ type: 'modifyList', payload: flowActions, useCache })
          onSuccess(flowActions)
        }
      } catch (err: any) {
        FailureHandler('Error fetching actions', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        let action = yield select((state: any) =>
          state.actions.list.find((action: Action) => action.id === id)
        )
        const org = yield select((state: any) => state.flowLayout.flow.organisation)
        const flow = yield select((state: any) => state.flowLayout.flow)
        const flowConfigVersion: any = yield select(
          (state: any) => state.flowLayout.version?.version
        )
        if (!action) {
          action = yield call(OrganisationsService.organisationsFlowsVersionsActionsRetrieve, {
            organisationUuid: org?.uuid,
            flowUuid: flow?.uuid,
            flowConfigVersion,
            id: id,
          })
        }
        yield put({ type: 'modifyList', payload: action })
        onSuccess(action)
      } catch (err) {
        FailureHandler('Could not find the action!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        // create and update pass flow_config
        console.info('create: ', data)
        const org = yield select((state: any) => state.flowLayout.flow.organisation)
        const flow = yield select((state: any) => state.flowLayout.flow)
        const flowConfigVersion: any = yield select(
          (state: any) => state.flowLayout.version?.version
        )
        const response = yield call(OrganisationsService.organisationsFlowsVersionsActionsCreate, {
          organisationUuid: org?.uuid,
          flowUuid: flow?.uuid,
          flowConfigVersion,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a action', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        const org = yield select((state: any) => state.flowLayout.flow.organisation)
        const flow = yield select((state: any) => state.flowLayout.flow)
        const flowConfigVersion: any = yield select(
          (state: any) => state.flowLayout.version?.version
        )
        const response = yield call(
          OrganisationsService.organisationsFlowsVersionsActionsPartialUpdate,
          {
            organisationUuid: org?.uuid,
            flowUuid: flow?.uuid,
            flowConfigVersion,
            id: id,
            requestBody: data,
          }
        )
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a action', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ): any {
      setLoading(true)
      try {
        const org = yield select((state: any) => state.flowLayout.flow.organisation)
        const flow = yield select((state: any) => state.flowLayout.flow)
        const flowConfigVersion: any = yield select(
          (state: any) => state.flowLayout.version?.version
        )
        yield call(OrganisationsService.organisationsFlowsVersionsActionsDestroy, {
          organisationUuid: org?.uuid,
          flowUuid: flow?.uuid,
          flowConfigVersion,
          id: id,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a action', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]

      if (action.useCache === false) {
        list = []
      }

      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Action) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Action) => !action.payload.map((p: Action) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Action) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
  },
}

export default Actions
